import {
  // About_US_Header_Icon,
  AI_Platform_Icon,
  Blogs_Header_Icon,
  // Career_Header_Icon,
  // Case_Study_Header_Icon,
  // Contact_Header_Icon,
  Data_Pipeline_Icon,
  Events_Webinars_Header_Icon,
  // FAQ_Header_Icon,
  Model_Fine_Icon,
  Powered_By_AI_Icon,
  Scalable_Integration_Icon,
  chat,
  call,
  DA_Header_Icon,
  Inference_Icon,
} from "../images";

export const headerDropdown = [
  {
    label: "Products",
    lists: [
      {
        title: "[AI] Platform",
        text: "Secure data infrastructure for collecting, processing and delivering enterprise data to LLM and agentic analytics applications.",
        icon: AI_Platform_Icon,
        link: "/ai-platform",
      },
      // {
      //   title: "PoweredByAI",
      //   text: "Ready-to-deploy AI models and custom development for African markets.",
      //   icon: Powered_By_AI_Icon,
      //   link: "/pllm",
      // },
      {
        title: "Data Assistant",
        text: "Enterprise analytics agent powered by LLMs, delivering explainable and actionable insights.",
        icon: DA_Header_Icon,
        link: "/data-assistant",
      },
    ],
  },
  {
    label: "Services",
    lists: [
      {
        title: "Model Customisation & Fine-Tuning",
        text: "Tailored model adaptation, supervised fine-tuning, and RLHF for African contexts.",
        icon: Model_Fine_Icon,
        link: "/model-evaluation",
      },
      {
        title: "Data Pipeline & Evaluation",
        text: "End-to-end data pipelines and structured evaluation or high-quality, reliable AI systems.",
        icon: Data_Pipeline_Icon,
        link: "/data-pipeline-and-evaluation",
      },
      {
        title: "Scalable Integrations",
        text: "Enterprise-ready integrations that connect AI models securely across platforms and workflows.",
        icon: Scalable_Integration_Icon,
        link: "/scalable-integrations",
      },
      {
        title: "AI Inference",
        text: "Secure infrastructure for deploying, hosting, and operating AI — fully under your control.",
        icon: Inference_Icon,
        link: "/ai-inference",
      },
    ],
  },
  {
    label: "AI Academy",
    link: "https://www.aiacademy.africa/"
  },
  {
    label: "Resources",
    lists: [
      {
        title: "Blogs",
        text: "",
        icon: Blogs_Header_Icon,
        link: "/blog",
      },
      // {
      //   title: "Case Studies",
      //   text: "",
      //   icon: Case_Study_Header_Icon,
      //   link: "/case-study",
      // },
      {
        title: "Events & Webinars",
        text: "",
        icon: Events_Webinars_Header_Icon,
        link: "/events",
      },
    ],
  },

  {
    label: "About Us",
    link: "/about-us"
  },
];

export const newFooterLinks = [
  {
    label: "Platform",
    links: [
      {
        label: "[AI] Platform",
        link: "/ai-platform",
      },
      {
        label: "PoweredByAI",
        link: "/",
      },
      {
        label: "AI Academy",
        link: "https://www.aiacademy.africa/",
      },
    ],
  },
  {
    label: "Quick links",
    links: [
      {
        label: "Model Evaluation",
        link: "/model-evaluation",
      },
      {
        label: "Data Pipelines & Evaluation",
        link: "/data-pipeline-and-evaluation",
      },
      {
        label: "Scalable Integration",
        link: "/scalable-integrations",
      },
    ],
  },
  {
    label: "Resources",
    links: [
      {
        label: "Blog",
        link: "/blog",
      },
      {
        label: "Events & Webinars",
        link: "/events",
      },
    ],
  },
  {
    label: "Company",
    links: [
      {
        label: "About Us",
        link: "/about-us",
      },
      // {
      //   label: "Careers",
      //   link: "/careers",
      // },
      // {
      //   label: "FAQs",
      //   link: "/faqs",
      // },
      {
        label: "Contact",
        link: "/contact",
      },
    ],
  },
  {
    label: "Legal",
    links: [
      {
        label: "Legal information",
        link: "/legal-info",
      },
      {
        label: "ISMS and BCMS policy",
        link: "/isms-bcms",
      },
    ],
  },

  {
    label: "Contact",
    links: [
      {
        label: "info@analyticsintelligence.com",
        link: "mailto:info@analytics intelligence.com",
      },
      {
        label: "sales@analyticsintelligence.com",
        link: "mailto:sales@analytics intelligence.com",
      },
      {
        label: "support@analyticsintelligence.com",
        link: "mailto:support@analyticsintelligence.com",
      },
      {
        label: "careers@analyticsintelligence.com",
        link: "mailto:careers@analyticsintelligence.com",
      },
    ],
  },
];

export const languages = [
  {
    label: "en",
    value: "english",
  },
  {
    label: "fr",
    value: "french",
  },
  {
    label: "ar",
    value: "arabic",
  },
  {
    label: "es",
    value: "spanish",
  },
];

// English Translations (default)
export const english = {
  questions: [
    "How do you deliver high-quality AI data at scale for Africa?",
    "What makes African language LLMs globally usable?",
    "How does your platform simplify AI evaluation, labeling, and deployment?",
  ],
  aiPlatformQuestions: [
    "What is the [AI] Platform ?",
    "How does the MCP Server enable contextual data enrichment?",
    "Who is the [AI] Platform designed for?",
  ],
  modelEvaluationQuestions: [
    "How do you ensure high-quality model evaluation and labeling?",
    "What annotation and evaluation services do you offer?",
    "How do you maintain accuracy, safety, and scale in AI data workflows?",
  ],
  dataPipelineAndEvaluationQuestions: [
    "How do your data pipelines ensure reliable AI performance?",
    "How is data quality monitored and validated continuously?",
    "How do you scale and manage pipelines in production environments?",
  ],
  scalableIntegrationQuestions: [
    "How do you integrate AI with existing enterprise systems?",
    "What types of AI integrations and APIs do you support?",
    "How do you ensure performance, security, and reliability at scale?",
  ],
  aboutUsQuestions: [
    "What mission and vision guide the company?",
    "What values shape how AI and data are built?",
    "Where does the company operate?",
  ],
  legalInfoPreviewQuestions: [
    "What personal data do you collect?",
    "How is my data used and protected?",
    "Who can my data be shared with?",
  ],
  securityAndContinuityPreviewQuestions: [
    "How is information kept secure?",
    "How do you handle disruptions or incidents?",
    "What standards guide security and continuity?",
  ],
  actions: [
    {
      action: "chat",
      desc: "Instant message with our help assistant [AI]Chat",
      icon: chat,
    },
    {
      action: "call",
      desc: "Schedule a Call with a customer care Representative",
      icon: call,
    },
  ],
  infoTexts: {
    moreInfo:
      "For more info on our product offerings, engage with [AI] Chat, or speak to a customer care representative.",
    scheduleCall:
      "For specific requests, kindly fill out this form to schedule a call with a customer care representative.",
    customerCareRep: "[AI] Customer Care Representative",
    scheduleMessage: "Please schedule a call with our customer representative.",
    feedbackThankYou: "Thank you for your feedback.",
    callRequestSuccess:
      "Call Request Successful, check your email for the call details.",
  },
  countries: [
    "Country",
    "Afghanistan",
    "Åland Islands",
    "Albania",
    "Algeria",
    /*...*/ "Zimbabwe",
  ],
};

// Spanish Translations
export const spanish = {
  questions: [
    "¿Cómo entregan datos de IA de alta calidad a escala para África?",
    "¿Qué hace que los LLM de lenguas africanas sean utilizables a nivel global?",
    "¿Cómo simplifica su plataforma la evaluación, el etiquetado y el despliegue de IA?",
  ],
  aiPlatformQuestions: [
    "¿Qué es la plataforma [AI]?",
    "¿Cómo permite el servidor MCP el enriquecimiento contextual de datos?",
    "¿Para quién está diseñada la plataforma [AI]?",
  ],
  modelEvaluationQuestions: [
    "¿Cómo garantizan una evaluación y un etiquetado de modelos de alta calidad?",
    "¿Qué servicios de anotación y evaluación ofrecen?",
    "¿Cómo mantienen la precisión, la seguridad y la escalabilidad en los flujos de datos de IA?",
  ],
  dataPipelineAndEvaluationQuestions: [
    "¿Cómo garantizan sus pipelines de datos un rendimiento fiable de la IA?",
    "¿Cómo se supervisa y valida la calidad de los datos de forma continua?",
    "¿Cómo escalan y gestionan los pipelines en entornos de producción?",
  ],
  scalableIntegrationQuestions: [
    "¿Cómo integran la IA con los sistemas empresariales existentes?",
    "¿Qué tipos de integraciones y APIs de IA admiten?",
    "¿Cómo garantizan el rendimiento, la seguridad y la fiabilidad a escala?",
  ],
  aboutUsQuestions: [
    "¿Qué misión y visión guían a la empresa?",
    "¿Qué valores dan forma a cómo se construyen la IA y los datos?",
    "¿Dónde opera la empresa?",
  ],
  legalInfoPreviewQuestions: [
    "¿Qué datos personales recopilan?",
    "¿Cómo se utilizan y protegen mis datos?",
    "¿Con quién se pueden compartir mis datos?",
  ],
  securityAndContinuityPreviewQuestions: [
    "¿Cómo se mantiene segura la información?",
    "¿Cómo gestionan las interrupciones o los incidentes?",
    "¿Qué normas guían la seguridad y la continuidad?",
  ],

  actions: [
    {
      action: "chat",
      desc: "Mensaje instantáneo con nuestro asistente de ayuda [AI]Chat",
      icon: chat,
    },
    {
      action: "call",
      desc: "Programar una llamada con un representante de atención al cliente",
      icon: call,
    },
  ],
  infoTexts: {
    moreInfo:
      "Para obtener más información sobre nuestras ofertas de productos, interactúe con [AI] Chat o hable con un representante de atención al cliente.",
    scheduleCall:
      "Para solicitudes específicas, complete este formulario para programar una llamada con un representante de atención al cliente.",
    customerCareRep: "[AI] Representante de atención al cliente",
    scheduleMessage:
      "Por favor, programe una llamada con nuestro representante de atención al cliente.",
    feedbackThankYou: "Gracias por sus comentarios.",
    callRequestSuccess:
      "Solicitud de llamada exitosa, revise su correo electrónico para los detalles de la llamada.",
  },
  countries: [
    "País",
    "Afganistán",
    "Islas Åland",
    "Albania",
    "Argelia",
    /*...*/ "Zimbabue",
  ],
};

// French Translations
export const french = {
  questions: [
    "Comment fournissez-vous des données d’IA de haute qualité à grande échelle pour l’Afrique ?",
    "Qu’est-ce qui rend les LLM des langues africaines utilisables à l’échelle mondiale ?",
    "Comment votre plateforme simplifie-t-elle l’évaluation, l’annotation et le déploiement de l’IA ?",
  ],
  aiPlatformQuestions: [
    "Qu’est-ce que la plateforme [AI] ?",
    "Comment le serveur MCP permet-il l’enrichissement contextuel des données ?",
    "À qui s’adresse la plateforme [AI] ?",
  ],
  modelEvaluationQuestions: [
    "Comment garantissez-vous une évaluation et une annotation de modèles de haute qualité ?",
    "Quels services d’annotation et d’évaluation proposez-vous ?",
    "Comment maintenez-vous la précision, la sécurité et la mise à l’échelle dans les flux de données IA ?",
  ],
  dataPipelineAndEvaluationQuestions: [
    "Comment vos pipelines de données garantissent-ils des performances fiables de l’IA ?",
    "Comment la qualité des données est-elle surveillée et validée en continu ?",
    "Comment mettez-vous à l’échelle et gérez-vous les pipelines en environnement de production ?",
  ],
  scalableIntegrationQuestions: [
    "Comment intégrez-vous l’IA aux systèmes d’entreprise existants ?",
    "Quels types d’intégrations et d’API d’IA prenez-vous en charge ?",
    "Comment garantissez-vous les performances, la sécurité et la fiabilité à grande échelle ?",
  ],
  aboutUsQuestions: [
    "Quelle mission et quelle vision guident l’entreprise ?",
    "Quelles valeurs façonnent la manière dont l’IA et les données sont construites ?",
    "Où l’entreprise opère-t-elle ?",
  ],
  legalInfoPreviewQuestions: [
    "Quelles données personnelles collectez-vous ?",
    "Comment mes données sont-elles utilisées et protégées ?",
    "Avec qui mes données peuvent-elles être partagées ?",
  ],
  securityAndContinuityPreviewQuestions: [
    "Comment les informations sont-elles protégées ?",
    "Comment gérez-vous les interruptions ou les incidents ?",
    "Quelles normes guident la sécurité et la continuité ?",
  ],

  actions: [
    {
      action: "chat",
      desc: "Message instantané avec notre assistant d'aide [AI]Chat",
      icon: chat,
    },
    {
      action: "call",
      desc: "Planifier un appel avec un représentant du service client",
      icon: call,
    },
  ],
  infoTexts: {
    moreInfo:
      "Pour plus d'informations sur nos offres de produits, engagez-vous avec [AI] Chat ou parlez à un représentant du service client.",
    scheduleCall:
      "Pour des demandes spécifiques, veuillez remplir ce formulaire pour planifier un appel avec un représentant du service client.",
    customerCareRep: "[AI] Représentant du service client",
    scheduleMessage:
      "Veuillez planifier un appel avec notre représentant client.",
    feedbackThankYou: "Merci pour vos commentaires.",
    callRequestSuccess:
      "Demande d'appel réussie, consultez votre e-mail pour les détails de l'appel.",
  },
  countries: [
    "Pays",
    "Afghanistan",
    "Îles Åland",
    "Albanie",
    "Algérie",
    /*...*/ "Zimbabwe",
  ],
};

// Arabic Translations
export const arabic = {
  questions: [
    "كيف تقدمون بيانات ذكاء اصطناعي عالية الجودة وعلى نطاق واسع لأفريقيا؟",
    "ما الذي يجعل نماذج اللغة الكبيرة للغات الأفريقية قابلة للاستخدام عالميًا؟",
    "كيف تُبسّط منصتكم تقييم الذكاء الاصطناعي ووسم البيانات ونشر النماذج؟",
  ],
  aiPlatformQuestions: [
    "ما هي منصة [AI]؟",
    "كيف يتيح خادم MCP إثراء البيانات بالسياق؟",
    "لمن صُممت منصة [AI]؟",
  ],
  modelEvaluationQuestions: [
    "كيف تضمنون جودة عالية في تقييم النماذج ووسم البيانات؟",
    "ما خدمات الوسم والتقييم التي تقدمونها؟",
    "كيف تحافظون على الدقة والأمان وقابلية التوسع في سير عمل بيانات الذكاء الاصطناعي؟",
  ],
  dataPipelineAndEvaluationQuestions: [
    "كيف تضمن خطوط البيانات لديكم أداءً موثوقًا للذكاء الاصطناعي؟",
    "كيف تتم مراقبة جودة البيانات والتحقق منها بشكل مستمر؟",
    "كيف تقومون بتوسيع وإدارة خطوط البيانات في بيئات الإنتاج؟",
  ],
  scalableIntegrationQuestions: [
    "كيف تدمجون الذكاء الاصطناعي مع أنظمة المؤسسات الحالية؟",
    "ما أنواع تكاملات وواجهات برمجة تطبيقات الذكاء الاصطناعي التي تدعمونها؟",
    "كيف تضمنون الأداء والأمان والموثوقية على نطاق واسع؟",
  ],
  aboutUsQuestions: [
    "ما الرسالة والرؤية التي توجه الشركة؟",
    "ما القيم التي تشكّل طريقة بناء الذكاء الاصطناعي والبيانات؟",
    "أين تعمل الشركة؟",
  ],
  legalInfoPreviewQuestions: [
    "ما البيانات الشخصية التي تقومون بجمعها؟",
    "كيف يتم استخدام بياناتي وحمايتها؟",
    "مع من يمكن مشاركة بياناتي؟",
  ],
  securityAndContinuityPreviewQuestions: [
    "كيف يتم الحفاظ على أمان المعلومات؟",
    "كيف تتعاملون مع الانقطاعات أو الحوادث؟",
    "ما المعايير التي توجه ممارسات الأمن واستمرارية الأعمال؟",
  ],
  actions: [
    { action: "chat", desc: "رسالة فورية مع مساعدنا [AI]Chat", icon: chat },
    { action: "call", desc: "جدولة مكالمة مع ممثل رعاية العملاء", icon: call },
  ],
  infoTexts: {
    moreInfo:
      "لمزيد من المعلومات حول عروض منتجاتنا، تواصل مع [AI] Chat، أو تحدث إلى ممثل رعاية العملاء.",
    scheduleCall:
      "للطلبات المحددة، يرجى ملء هذا النموذج لتحديد موعد مكالمة مع ممثل رعاية العملاء.",
    customerCareRep: "[AI] ممثل رعاية العملاء",
    scheduleMessage: "يرجى تحديد موعد مكالمة مع ممثل خدمة العملاء.",
    feedbackThankYou: "شكرًا لك على ملاحظاتك.",
    callRequestSuccess:
      "تم طلب المكالمة بنجاح، يرجى التحقق من بريدك الإلكتروني للحصول على تفاصيل المكالمة.",
  },
  countries: [
    "البلد",
    "أفغانستان",
    "جزر آلاند",
    "ألبانيا",
    "الجزائر",
    /*...*/ "زيمبابوي",
  ],
};

export const l = {
  arabic,
  english,
  french,
  spanish,
};

export const prefilledQuestions = (pathname, langKey) => {
  const lang = l[langKey];

  if (!lang) {
    console.error(`Language ${langKey} not found!`);
    return [];
  }

  switch (pathname) {
    case "/ai-platform":
      return lang?.aiPlatformQuestions;
    case "/model-evaluation":
      return lang?.modelEvaluationQuestions;
    case "/data-pipeline-and-evaluation":
      return lang?.dataPipelineAndEvaluationQuestions;
    case "/scalable-integrations":
      return lang?.scalableIntegrationQuestions;
    case "/about-us":
      return lang?.aboutUsQuestions;
    case "/legal-info":
      return lang?.legalInfoPreviewQuestions;
    case "/isms-bcms":
      return lang?.securityAndContinuityPreviewQuestions;
    default:
      return lang?.questions;
  }
};
